import { Controller } from "@hotwired/stimulus"

// Charge card's total (Events v2 K2). As staff tick the balance (or lower its amount) and add charges, the server works out
// what the card is charged with the code that charges it, so the sheet never does its own sums (service charge, tax
// and the minimum spend all count) or shows a number the charge wouldn't be. The button says the amount, and is off
// while the balance is unticked with no charge added, as is the balance's amount while it's unticked. The password and
// note never leave the form. A refusal's banner goes once the charge is changed, and stays through a password edit.
const SHEET = /^party_payment\[(charge|amount|extras)\]/

export default class extends Controller {
  static targets = ["total", "submit"]
  static values = { url: String }

  disconnect() {
    clearTimeout(this.timer)
    this.request?.abort()
  }

  refresh(event) {
    const name = event?.target?.name
    if (name && !SHEET.test(name)) return

    this.element.querySelector("[role=alert]")?.remove()
    // A stale total must not sit beside the button while the new one loads.
    this.show(null)
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.load(), 250)
  }

  async load() {
    this.request?.abort()
    const request = new AbortController()
    this.request = request
    const url = new URL(this.urlValue, window.location.href)
    for (const [name, value] of new FormData(this.element)) {
      if (SHEET.test(name)) url.searchParams.append(name, value)
    }
    try {
      const response = await fetch(url, { signal: request.signal, headers: { Accept: "text/html" } })
      if (!response.ok) throw new Error(`Total failed: ${response.status}`)
      this.show(await response.text())
    } catch (error) {
      if (error.name === "AbortError") return
      // The charge is still worked out on the server when it's sent; the sheet just shows no number meanwhile.
      this.show(null)
    }
  }

  // html is the total partial, or null to blank its amounts (kept in place, so nothing under them moves) until the
  // next one.
  show(html) {
    if (html !== null) this.totalTarget.innerHTML = html
    this.totalTarget.classList.toggle("is-loading", html === null)
    const label = html === null ? null : this.totalTarget.querySelector("[data-label]")?.dataset.label
    if (!this.hasSubmitTarget) return

    this.submitTarget.textContent = label || "Charge"
    const balance = this.element.querySelector("#party_payment_charge_balance")
    if (!balance) return

    this.element.querySelector("#party_payment_amount").disabled = !balance.checked
    this.submitTarget.disabled = !balance.checked && !this.element.querySelector(".ev-extra")
  }
}
